<script>
import PickKupecInline from '@/components/PickKupecInline';
import service from '@/service';

export default {
	components: {
		'pick-kupec-inline': PickKupecInline
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function (id) {
			this.item_id = id;
			// select current user
			this.prodajalci_selected = null;
			for (let item of this.vsiProdajalci) {
				if (this.user.email === item.email) {
					this.prodajalci_selected = item;
					break;
				}
			}
			// enable editing for super admins
			if (this.user.role === 5) {
				this.prodajalci_disabled = false;
				this.trajanja_disabled = false;
				this.trajanje_value = 1;
			}
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			if (!this.item_id) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}
			// submit prodaja
			this.showError(null);
			this.in_progress = true;
			service.rezervirajVozilo(this.item_id, this.prodajalci_selected, this.kupec_selected, this.trajanje_value)
				.then(response => {
					this.$refs.modal.hide();
					this.clearModalData();
					this.$emit('reservation-success');
				})
				.catch(error => {
					this.in_progress = false;
					this.processAddError(error);
				});
		},
		processAddError: function (error) {
			if (!error) {
				this.showError('Napaka pri prezervaciji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Rezervacija ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Rezervacija ni uspela (U)');
				return;
			}
			this.showError(`${error.response.data.message} (#${error.response.data.code})`);
		},
		clearModalData: function () {
			this.kupec_selected = null;
			this.trajanje_value = 1;
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
		},
		loadProdajalci: function () {
			this.prodajalci_options = [];
			service.getProdajalci()
				.then(prodajalci => {
					for (let item of prodajalci) {
						item.full_name = item.first_name + ' ' + item.last_name;
					}
					this.prodajalci_options = prodajalci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		showError: function (message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		}
	},
	data: function () {
		return {
			item_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			trajanja_disabled: true,
			trajanje_value: 1,
			action_message_type: null,
			action_message: null,
			in_progress: false,
			ACTION_TYPE_ERROR: 'ERROR'
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		vsiProdajalci () {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Rezerviraj vozilo" class="modal-primary" :busy="in_progress" ok-title="Potrdi" cancel-title="Prekliči" @ok="onOkModal">
		<b-row>
			<b-col>
				<b-form-group>
					<label>Prodajalec</label>
					<v-select ref="prodajalci"
						v-model="prodajalci_selected"
						:options="vsiProdajalci"
						:disabled="prodajalci_disabled"
						label="full_name"
						placeholder="Izberi prodajalca ...">
					</v-select>
				</b-form-group>
			</b-col>
		</b-row>
		<pick-kupec-inline ref="pickKupec" v-model="kupec_selected" :kupci="kupci" title="Kupec" />
		<b-row>
			<b-col>
				<b-form-group>
					<label for="trajanje">Čas rezervacije (v dneh)</label>
					<b-form-input v-model="trajanje_value" :disabled="trajanja_disabled" type="number" id="trajanje" placeholder="Trajanje rezervacije v dneh"></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-alert :variant="action_message_type && action_message_type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="action_message && action_message !== ''">{{ action_message }}</b-alert>
	</b-modal>
</template>
<style>
.dropdown-toggle::after {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/RezervirajVoziloModal.vue